// extracted by mini-css-extract-plugin
export default {"siriusPagination":"index-module--siriusPagination--og-FK"};